import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "auth__wrap" }
const _hoisted_2 = { class: "auth__container" }

import { onBeforeUnmount, onMounted, ref, watch } from "vue";
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";
import WelcomeStep from "@/components/auth/WelcomeStep.vue";
import PhoneStep from "@/components/auth/PhoneStep.vue";
import CodeStep from "@/components/auth/CodeStep.vue";
import { sendOtp } from "@/server/api/send-otp.get";
import { getPhoneNumber, getTokenFromCookies } from "@/utils/common";
import { useStore } from "vuex";


export default /*@__PURE__*/_defineComponent({
  __name: 'Auth',
  setup(__props) {

const { t } = useI18n();

const store = useStore();
const router = useRouter();

const step = ref<"welcome" | "phone" | "code">("welcome");
const phone = ref("");
const isWrongPhone = ref(false);
const isLoadingRequestOtp = ref(false);
const errorCodeCount = ref(0);

const handlePhoneSubmit = async (submittedPhone: string) => {
  phone.value = getPhoneNumber(submittedPhone);
  isLoadingRequestOtp.value = true;
  store
    .dispatch("auth/requestOtp", {
      msisdn: phone.value,
    })
    .then((response) => {
      if (!response) return;
      if (response.data?.status) {
        isWrongPhone.value = false;
        step.value = "code";
      } else {
        isWrongPhone.value = true;
      }
    })
    .catch((err) => {
      //TODO: в модалку перененсти? в стор
      alert(t("auth.errors.service"));
    })
    .finally(() => {
      isLoadingRequestOtp.value = false;
    });
};

const handleCodeSubmit = async (code: string) => {
  store
    .dispatch("auth/verifyOtp", {
      msisdn: phone.value,
      code,
    })
    .then((data) => {
      if (!data) return;
      if (data.status) router.push("/account");
      else errorCodeCount.value++;
    })
    .catch((err) => {
      //TODO: перенсти в стор
      alert(t("auth.errors.service"));
    });
};

const handleResendCode = () => {
  handlePhoneSubmit(phone.value);
};

watch(step, (newStep) => {
  store.dispatch(
    "updateLogoVisibility",
    ["phone", "code", "welcome"].includes(newStep)
  );
});

onMounted(() => {
  if (getTokenFromCookies()) {
    store.dispatch("auth/setAuth", true);
    router.push("/account");
  }

  if (step.value === "welcome") {
    store.dispatch("updateLogoVisibility", true);
  }
});

onBeforeUnmount(() => {
  store.dispatch("updateLogoVisibility", false);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (step.value === 'welcome')
        ? (_openBlock(), _createBlock(WelcomeStep, {
            key: 0,
            onLogin: _cache[0] || (_cache[0] = ($event: any) => (step.value = 'phone'))
          }))
        : (step.value === 'phone')
          ? (_openBlock(), _createBlock(PhoneStep, {
              key: 1,
              "is-wrong-phone": isWrongPhone.value,
              onBack: _cache[1] || (_cache[1] = ($event: any) => (step.value = 'welcome')),
              onSubmit: handlePhoneSubmit,
              isWrongPhone: isWrongPhone.value,
              isLoadingBtn: isLoadingRequestOtp.value
            }, null, 8, ["is-wrong-phone", "isWrongPhone", "isLoadingBtn"]))
          : (step.value === 'code')
            ? (_openBlock(), _createBlock(CodeStep, {
                key: 2,
                ref: "codeStepRef",
                phone: phone.value,
                "error-count": errorCodeCount.value,
                onBack: _cache[2] || (_cache[2] = ($event: any) => (step.value = 'phone')),
                onSubmit: handleCodeSubmit,
                onResend: handleResendCode
              }, null, 8, ["phone", "error-count"]))
            : _createCommentVNode("", true)
    ])
  ]))
}
}

})